import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function Header() {
  return <header className="py-3 md:py-4" data-id="element-46">
      <div className="bg-red-600 text-white p-2 mb-3 md:mb-4 flex items-center justify-center text-xs md:text-sm font-medium rounded" data-id="element-47">
        <AlertTriangleIcon className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2" data-id="element-48" />
        <span data-id="element-49">Circulation Expert Reveals</span>
      </div>
      <div className="flex justify-between items-center text-xs text-gray-500 mb-3 md:mb-4" data-id="element-50">
        <span data-id="element-51">Health & Vitality Journal</span>
        <span className="hidden sm:inline" data-id="element-52">August 18, 2025</span>
        <span data-id="element-53">Sponsored</span>
      </div>
      <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4 leading-tight" data-id="element-54">
        Big Pharma's $4 Billion Cover-Up: The Spice That Fixes Poor Circulation
      </h1>
      <p className="text-base md:text-lg text-gray-700 mb-4 md:mb-6" data-id="element-55">
        47-year-old retired veteran discovers the kitchen remedy pharmaceutical
        companies spent billions trying to suppress.
      </p>
      <div className="h-px bg-gray-200 w-full mb-4 md:mb-6" data-id="element-56"></div>
    </header>;
}